// ScheduleList Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import ScheduleListItem from '../../../common/user/schedule_list_item/schedule_list_item.jsx'
import Button from '../../../common/common/button/button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class ScheduleList extends Component {
  static get propTypes () {
    return {
      scheduleOptions: PropTypes.array,
      onAddSchedule: PropTypes.func,
      onClickSetting: PropTypes.func,
      showheader: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      scheduleOptions: [],
      onAddSchedule: null,
      onClickSetting: null,
      showheader: true
    }
  }

  render () {
    const _schudleCls = classnames('schedule-list', {
      hideheader: !this.props.showheader
    })

    return (
      <div className={_schudleCls}>
        <div className='schedulelisthdr'>
          {this.props.showheader && (
            <div className='schtitle'>
              <IntlMessage ident='user.schedule.scheduleLabel' />
            </div>
          )}
          <div className='scheduleact'>
            <Button
              className='button_save'
              title='user.schedule.addSchedule'
              type='button'
              icon='common-add'
              canHover={false}
              onClick={this._onAddSchedule.bind(this)}
            />
          </div>
        </div>
        {this._renderScheduleitems()}
      </div>
    )
  }

  _onAddSchedule () {
    if (this.props.onAddSchedule) {
      this.props.onAddSchedule()
    }
  }

  _onSetting (scheduleOption) {
    if (this.props.onClickSetting) {
      this.props.onClickSetting(scheduleOption)
    }
  }

  /* Private functions */
  _renderScheduleitems () {
    const scheduleOptions = this.props.scheduleOptions
    if (scheduleOptions.length > 0) {
      return scheduleOptions.map((scheduleOption, idx) => {
        return (
          <ScheduleListItem
            key={scheduleOption.id}
            expand={idx === 0}
            schedule={scheduleOption}
            onSetting={this._onSetting.bind(this, scheduleOption)}
          />
        )
      })
    }

    return ''
  }
}

export default ScheduleList
